import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Grid } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/grid';
import productData from '../data/products..json';
import { useNavigate } from "react-router-dom";

const Products = () => {
    const products = productData.products;
    const navigate = useNavigate();

    const handleNavigateClick = (productId) => {
        navigate(`/productDetail/${productId}`);
    }

    return (
        <section
            id="products"
            className="min-h-screen flex flex-col justify-center pt-20 pb-12 bg-cover bg-center relative"
            style={{ backgroundImage: 'url("/Images/products-background.jpg")' }}
        >
            <div className="absolute inset-0 bg-black bg-opacity-50"></div>

            <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 space-y-8 lg:space-y-12">

                {/* Header Section */}
                <div className="flex flex-col items-center justify-center space-y-4 text-center">
                    <p className="text-lg sm:text-xl lg:text-2xl text-white font-lato font-thin">
                        Kesintisiz Oyun Deneyimi
                    </p>
                    <h2 className="text-3xl sm:text-3xl lg:text-4xl xl:text-6xl font-bold text-white font-montserrat leading-tight">
                        ÖZEL MASAÜSTÜLER
                    </h2>
                    <p className="text-sm sm:text-base lg:text-lg text-white font-montserrat max-w-3xl leading-relaxed">
                        Hemen harekete geçin ve bu canavar oyuncu bilgisayarını siz de edinin!
                        <br className="hidden sm:block" />
                        Rakiplerinizi geride bırakın ve oyun dünyasının hakimi olun!
                    </p>
                </div>

                {/* Swiper Section */}
                <div className="w-full max-w-7xl mx-auto">
                    <Swiper
                        spaceBetween={20}
                        slidesPerView={1}
                        navigation={true}
                        pagination={{
                            clickable: true,
                            dynamicBullets: true
                        }}
                        modules={[Navigation, Pagination, Grid]}
                        breakpoints={{
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 15,
                                grid: {
                                    rows: 1,
                                    fill: 'row'
                                }
                            },
                            640: {
                                slidesPerView: 1,
                                spaceBetween: 20,
                                grid: {
                                    rows: 1,
                                    fill: 'row'
                                }
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 25,
                                grid: {
                                    rows: 1
                                }
                            },
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 30,
                                grid: {
                                    rows: 1
                                }
                            }
                        }}
                        className="w-full py-8 px-4"
                    >
                        {products.map((product) => (
                            <SwiperSlide key={product.id} className="h-auto">
                                <div
                                    className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-lg border border-white/20 rounded-2xl shadow-xl p-4 md:p-6 text-white cursor-pointer transform hover:scale-100 hover:shadow-2xl hover:from-white/15 hover:to-white/8 transition-all duration-300 h-full group"
                                    onClick={() => handleNavigateClick(product.id)}
                                >
                                    {/* Başlık */}
                                    <div className="mb-4 md:mb-6 text-center">
                                        <h3 className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold font-montserrat leading-tight group-hover:text-[#f1f0ea] transition-colors duration-300">
                                            {product.name}
                                        </h3>
                                        <p className="text-xs sm:text-sm text-gray-300 font-lato mt-1">
                                            {product.category}
                                        </p>
                                    </div>

                                    {/* Ana İçerik - Resim ve Özellikler */}
                                    <div className="flex flex-col gap-4 mb-4 md:mb-6">
                                        {/* Ürün Resmi */}
                                        <div className="w-full">
                                            <div className="relative overflow-hidden rounded-xl bg-gradient-to-br from-black/20 to-black/10 p-2 md:p-4">
                                                <img
                                                    src={product.images.gallery[1]}
                                                    alt={product.name}
                                                    className="w-full h-24 sm:h-32 md:h-40 lg:h-48 object-contain group-hover:scale-110 transition-transform duration-500"
                                                />
                                                {/* Hover overlay */}
                                                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl"></div>
                                            </div>
                                        </div>

                                        {/* Özellikler */}
                                        <div className="w-full">
                                            <div className="space-y-2 text-xs sm:text-sm text-gray-300">
                                                <div className="flex justify-between items-center py-1 border-b border-white/10">
                                                    <span>Grafik:</span>
                                                    <span className="font-semibold text-white text-right text-xs">{product.specs.graphics.model}</span>
                                                </div>
                                                <div className="flex justify-between items-center py-1 border-b border-white/10">
                                                    <span>VRAM:</span>
                                                    <span className="font-semibold text-white">{product.specs.graphics.memory}</span>
                                                </div>
                                                <div className="flex justify-between items-center py-1 border-b border-white/10">
                                                    <span>CPU:</span>
                                                    <span className="font-semibold text-white text-right text-xs">{product.specs.processor.model}</span>
                                                </div>
                                                <div className="flex justify-between items-center py-1">
                                                    <span>RAM:</span>
                                                    <span className="font-semibold text-white">{product.specs.memory.capacity}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Alt Kısım - Detay Butonu */}
                                    <div className="text-center mt-auto">
                                        <div className="bg-gradient-to-r from-[#ad2831] to-[#540b0e] text-white px-4 py-2 md:px-6 md:py-3 rounded-lg font-semibold text-xs md:text-sm group-hover:from-[#540b0e] group-hover:to-[#ad2831] transition-all duration-300 transform group-hover:scale-105">
                                            Detayları Görüntüle
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
};

export default Products;